// FC246/#1281: render and validate a server-issued preview, never calculate an eBay target client-side.
export const actionLabel = (action) => ({
  replenish: "Replenish linked eBay listing",
  relist: "Relist existing eBay offer",
  create_draft: "Create local draft (not published)",
  manual_review: "Manual review required",
}[action] || "Not previewed");

export const canApproveDeferredEbay = (preview, approved, submitting) =>
  Boolean(preview && preview.status === "ready_for_approval" && preview.preview_token &&
    Number.isInteger(Number(preview.proposed_quantity)) &&
    ["replenish", "relist", "create_draft"].includes(preview.action) && approved && !submitting);

export const deferredEbayRoleRows = (events) => (events || []).flatMap((event) => [
  ...(Number(event.singles) > 0 ? [{ ...event, role: "single", quantity: Number(event.singles),
    status: event.single_status || "unreviewed", action: event.single_action }] : []),
  ...(Number(event.playsets) > 0 ? [{ ...event, role: "playset", quantity: Number(event.playsets),
    status: event.playset_status || "unreviewed", action: event.playset_action }] : []),
]);
